import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, Moon, ShoppingBag, Activity } from 'lucide-react';
export function ProductSection() {
  const features = [{
    icon: <Coffee className="w-6 h-6 text-coral-500" data-id="element-42" />,
    title: 'The 90-Minute Caffeine Rule',
    desc: 'How to use coffee as a tool, not a crutch.'
  }, {
    icon: <Activity className="w-6 h-6 text-sage-500" data-id="element-43" />,
    title: 'The Vagus Nerve Reset',
    desc: '2-minute hacks to stop anxiety in its tracks.'
  }, {
    icon: <Moon className="w-6 h-6 text-charcoal-700" data-id="element-44" />,
    title: 'The 3-2-1 Sleep Architecture',
    desc: 'The exact US-based evening routine for deep REM.'
  }, {
    icon: <ShoppingBag className="w-6 h-6 text-sage-500" data-id="element-45" />,
    title: 'The Anti-Inflammatory Grocery Guide',
    desc: "Walmart, Target, and Whole Foods 'Safe Lists.'"
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-cream" data-id="element-46">
      <div className="max-w-5xl mx-auto" data-id="element-47">
        <div className="text-center mb-16" data-id="element-48">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-49">
            <h2 className="text-sm font-bold tracking-widest text-sage-600 uppercase mb-4" data-id="element-50">
              Introducing
            </h2>
            <h3 className="text-4xl sm:text-5xl font-display font-bold text-charcoal-800 mb-6" data-id="element-51">
              "The Cortisol Code"
            </h3>
            <p className="text-xl text-charcoal-700/80 max-w-2xl mx-auto" data-id="element-52">
              The complete, step-by-step 7-Day Protocol to reset your nervous
              system from your living room.
            </p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-53">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-54">
            <img src="https://cdn.magicpatterns.com/uploads/a4cuGvgfZDWzyrzckcnfDZ/mockup.png" alt="The Cortisol Code — complete bundle including the main guide, Stress Response Journal, Sleep Hygiene Workbook, Nutrition Guide, Mindfulness Practices, Daily Balance Checklist, video library, and shopping list app" className="w-full rounded-2xl shadow-xl" data-id="element-55" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-56">
            <h4 className="text-2xl font-bold mb-8" data-id="element-57">
              What's waiting for you inside:
            </h4>
            <div className="space-y-8" data-id="element-58">
              {features.map((feature, index) => <div key={index} className="flex gap-4" data-id="element-59">
                  <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center shrink-0" data-id="element-60">
                    {feature.icon}
                  </div>
                  <div data-id="element-61">
                    <h5 className="text-lg font-bold text-charcoal-800 mb-1" data-id="element-62">
                      {feature.title}
                    </h5>
                    <p className="text-charcoal-700/80" data-id="element-63">{feature.desc}</p>
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}